<template>
  <div class="item-container" @click="navToDetail()">
    <div class="item-title">
      <div
        v-if="order.usingEndDate || (orderType === 'GOODS' && statusType !== 0)"
        class="item-date"
      >
        <img src="@/assets/img/calendar.svg" />
        <span v-if="statusType === 4">
          聯絡客服 {{ order.issueOpenDate | formatDateTime('dateSimple') }}
        </span>
        <span v-else-if="statusType === 3">
          {{ orderType === 'GOODS' ? '退貨申請日期' : '退款申請日期' }}
          {{ order.returnApplyDate | formatDateTime('dateSimple') }}
        </span>
        <template v-else-if="orderType === 'GOODS'">
          <span v-if="statusType === 1">
            出貨日期 {{ order.shipDate | formatDateTime('dateSimple') }}
          </span>
          <span v-else>
            鑑賞日期 {{ order.trialLastDate | formatDateTime('dateSimple') }}
          </span>
        </template>
        <template v-else>
          <span>
            使用期限 {{ order.usingEndDate | formatDateTime('dateSimple') }}
          </span>
        </template>
      </div>
      <div class="item-state" align="right" v-if="statusType !== 4">
        <div class="pill-badge pill-badge_title">
          <span v-if="statusType === 0 && orderType !== 'GOODS'" class="remain">
            {{ '剩餘次數：' + order.availableQty }}
          </span>
          <span v-else-if="statusType === 1 && orderType !== 'GOODS'">
            使用完畢
          </span>
          <span v-else-if="statusType === 2">
            {{ orderType !== 'GOODS' ? '票券過期' : getTrialStatus }}
          </span>
          <span v-else-if="statusType === 3">
            {{ order.returnStatus === 5 ? '退款失敗' : order.returnStatusDesc }}
          </span>
        </div>
      </div>
    </div>
    <div class="item-body">
      <div class="item-image">
        <img onerror="this.style.display= 'none';" :src="order.imgUrl" />
      </div>
      <div class="item-info">
        <div v-if="order.deliver" class="pill-badge pill-badge_deliver">
          {{ order.deliver }}
        </div>
        <p v-if="orderType === 'GOODS'" class="item-info-delivery">
          {{ order.deliveryTypeDesc }}
        </p>
        <div class="item-info-product">{{ order.productName }}</div>
        <div v-if="order.orderSpec" class="item-info-text_grey">
          商品規格：{{ order.orderSpec }}
        </div>
        <div class="item-info-text_grey">購買數量：{{ order.buyQty }}</div>
        <div class="item-info-price">付款金額：${{ order.payAmount }}</div>
        <div v-show="order.isGroupCoupon" class="product-type">成套票券</div>
        <div
          v-if="order.lastServiceNo"
          class="item-info-bottom item-info-text_grey"
          @click.stop="goContact()"
        >
          客服紀錄
          <img class="ml-2" src="@/assets/img/arrow-right.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderItem',
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    orderType: {
      type: String,
      default: '',
    },
    statusType: {
      type: Number,
      default: 2,
    },
  },
  methods: {
    navToDetail: function() {
      this.$router.push({
        name: 'orderDetail',
        params: {
          oid: this.order.orderId,
          lastServiceNo: this.order.lastServiceNo
            ? this.order.lastServiceNo
            : 0,
          nOid: this.order.newOrderNo || '1',
        },
      })
    },
    goContact() {
      console.log('lastServiceNo:' + this.order.lastServiceNo)
      this.$router.push({
        name: 'serviceAskingPage',
        params: {
          type: 1,
          serviceNo: this.order.lastServiceNo,
        },
      })
    },
  },
  computed: {
    getTrialStatus() {
      const today = this.$moment().format('YYYY/MM/DD')
      const trialDate = this.$moment(this.order.trialLastDate).format(
        'YYYY/MM/DD'
      )
      if (today > trialDate) {
        return '已過鑑賞期'
      }
      return '確認收貨'
    },
  },
}
</script>

<style lang="scss" scoped>
.product-type {
  min-width: 66px;
  height: 17px;
  border-radius: 8px;
  background-color: #fff6e0;
  color: #ff8c00;
  font-size: 12px;
  padding: 0 8px;
  bottom: 0px;
  position: absolute;
  bottom: 0px;
}

.item-container {
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: 0 1px 0 0 #e0e0e0;
}

.item-title {
  display: flex;
  flex-direction: row;
}

.item-date {
  display: flex;
  font-size: 13px;
  color: #4a4a4a;
  padding: 2px 0px 18px;
  text-align: left;
  flex: 1;
  span {
    margin-left: 8px;
  }
}

.item-body {
  flex: 1;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

.item-image {
  width: 27.9%;
  height: 0;
  padding-bottom: 27.9%;
  background: url('../../assets/img/placholder_512.svg');
  background-size: contain;
  background-repeat: no-repeat;
  img {
    width: 100%;
  }
}

.item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 8px;
  text-align: left;
  overflow: hidden;
  position: relative;
}

.item-info-delivery {
  display: inline-block;
  height: 17px;
  border-radius: 8px;
  background-color: rgba(22, 150, 255, 0.08);
  color: #1696ff;
  font-size: 12px;
  padding: 0 8px;
  margin: 0 auto 8px 0;
}

.item-info-group-coupon {
  display: inline-block;
  width: 64px;
  height: 17px;
  border-radius: 8px;
  background-color: rgba(22, 150, 255, 0.08);
  color: #ff8c00;
  font-size: 12px;
  padding: 0 8px;
  margin: 0 auto 8px 0;
}

.item-info-text_grey {
  font-size: 13px;
  color: #9b9b9b;
}

.item-info-product {
  font-size: 15px;
  font-weight: bold;
  color: #222222;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.item-info-bottom {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0px;
  right: 0px;
}

.item-info-bottom > img {
  width: 7px;
  height: 12px;
  object-fit: contain;
}

.item-info-price {
  font-size: 13px;
  color: #4a4a4a;
}

.pill-badge {
  width: fit-content;
  padding: 2px 12px;
  border-radius: 21px;
}

.pill-badge_title {
  background-color: #edf0f2 !important;
  color: #6d7278;
  font-size: 13px;
  .remain {
    color: #222;
  }
}
.pill-badge_deliver {
  background-color: rgba(22, 150, 255, 0.08) !important;
  color: #1696ff;
  margin-bottom: 8px;
}
</style>
